
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"13","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.945.305c1.12 0 2.151.258 3.094.773a5.496 5.496 0 012.211 2.18c.537.937.805 1.995.805 3.172 0 1.146-.26 2.187-.782 3.125a5.601 5.601 0 01-2.203 2.203c-.942.531-1.984.797-3.125.797-1.135 0-2.177-.263-3.125-.79A5.563 5.563 0 011.625 9.57c-.52-.937-.781-1.984-.781-3.14 0-1.172.265-2.227.797-3.164a5.563 5.563 0 012.203-2.188C4.78.562 5.815.305 6.945.305zm-3.101 10.07a4.8 4.8 0 003.094 1.094c.921 0 1.752-.216 2.492-.649.244-.14.468-.3.672-.476L6.96 7.227l-3.117 3.148zm3.094-8.984a4.803 4.803 0 00-3.102 1.093L6.96 5.641l3.11-3.149a4.737 4.737 0 00-.665-.469c-.734-.421-1.557-.632-2.469-.632zM6.163 6.43L3.078 3.32a3.782 3.782 0 00-.312.508C2.349 4.6 2.14 5.466 2.14 6.43c0 .958.203 1.823.609 2.593.099.183.208.357.328.524L6.164 6.43zm4.984 2.586c.407-.771.61-1.633.61-2.586 0-.97-.208-1.839-.625-2.61a6.46 6.46 0 00-.297-.492L7.758 6.43l3.101 3.078c.104-.156.2-.32.29-.492z","fill":"currentColor"}})])
          )
        }
      }
    